import type { SingleOpportunity } from '@ps/isp-web-services-types';

import type { Selection } from '../types';

export const getSelectionsFromSingleOpportunities = (singles: SingleOpportunity[]): Selection[] =>
  singles.map((opportunity) => ({
    selectionId: opportunity.runnerId.selectionId,
    marketId: opportunity.runnerId.marketId,
    eventId: opportunity.eventId,
    legType: 'legCombinations' in opportunity ? opportunity.legCombinations[0].legType : ''
  }));
